import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Box, 
  Container, 
  Grid, 
  Typography, 
  IconButton,
  List,
  ListItem,
  ListItemText
} from '@mui/material';
import { LinkedIn as LinkedInIcon } from '@mui/icons-material';

const Footer = () => {
  return (
    <Box component="footer" sx={{ bgcolor: '#1e293b', color: 'white' }}>
      <Container maxWidth="xl" sx={{ py: { xs: 8, md: 16 } }}>
        <Grid container spacing={4}>
          {/* Logo and Description */}
          <Grid item xs={12} md={6}>
            <Typography
              variant="h5"
              component={Link}
              to="/"
              sx={{
                fontWeight: 700,
                color: 'white',
                textDecoration: 'none',
                display: 'inline-block',
                mb: 2,
                '&:hover': {
                  textDecoration: 'none'
                }
              }}
            >
              UnisynHub
            </Typography>
            <Typography 
              variant="body2" 
              sx={{ 
                color: '#cbd5e1', // healthcare-blue-200
                lineHeight: 1.6,
                mb: 2,
                maxWidth: 400
              }}
            >
              The unified platform for regenerative medicine ecommerce, inventory management, 
              and fulfillment. Trusted by clinics, med spas, and equine specialists.
            </Typography>
            <Box>
              <IconButton
                href="#"
                sx={{
                  color: '#94a3b8', // healthcare-blue-300
                  '&:hover': { color: 'white' },
                  p: 1
                }}
                aria-label="LinkedIn"
              >
                <LinkedInIcon />
              </IconButton>
            </Box>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography 
              variant="overline" 
              sx={{ 
                fontWeight: 600, 
                color: 'white', 
                letterSpacing: 1.5,
                mb: 2,
                display: 'block'
              }}
            >
              Quick Links
            </Typography>
            <List sx={{ p: 0 }}>
              <ListItem sx={{ px: 0, py: 0.5 }}>
                <ListItemText
                  primary={
                    <Typography
                      component={Link}
                      to="/products"
                      variant="body2"
                      sx={{
                        color: '#cbd5e1',
                        textDecoration: 'none',
                        '&:hover': { color: 'white' }
                      }}
                    >
                      Products
                    </Typography>
                  }
                />
              </ListItem>
              <ListItem sx={{ px: 0, py: 0.5 }}>
                <ListItemText
                  primary={
                    <Typography
                      component={Link}
                      to="/insights"
                      variant="body2"
                      sx={{
                        color: '#cbd5e1',
                        textDecoration: 'none',
                        '&:hover': { color: 'white' }
                      }}
                    >
                      Insights
                    </Typography>
                  }
                />
              </ListItem>
              <ListItem sx={{ px: 0, py: 0.5 }}>
                <ListItemText
                  primary={
                    <Typography
                      component={Link}
                      to="/login"
                      variant="body2"
                      sx={{
                        color: '#cbd5e1',
                        textDecoration: 'none',
                        '&:hover': { color: 'white' }
                      }}
                    >
                      Login
                    </Typography>
                  }
                />
              </ListItem>
            </List>
          </Grid>

          {/* Legal */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography 
              variant="overline" 
              sx={{ 
                fontWeight: 600, 
                color: 'white', 
                letterSpacing: 1.5,
                mb: 2,
                display: 'block'
              }}
            >
              Legal
            </Typography>
            <List sx={{ p: 0 }}>
              <ListItem sx={{ px: 0, py: 0.5 }}>
                <ListItemText
                  primary={
                    <Typography
                      component={Link}
                      to="/privacy"
                      variant="body2"
                      sx={{
                        color: '#cbd5e1',
                        textDecoration: 'none',
                        '&:hover': { color: 'white' }
                      }}
                    >
                      Privacy Policy
                    </Typography>
                  }
                />
              </ListItem>
              <ListItem sx={{ px: 0, py: 0.5 }}>
                <ListItemText
                  primary={
                    <Typography
                      component={Link}
                      to="/contact"
                      variant="body2"
                      sx={{
                        color: '#cbd5e1',
                        textDecoration: 'none',
                        '&:hover': { color: 'white' }
                      }}
                    >
                      Contact
                    </Typography>
                  }
                />
              </ListItem>
              <ListItem sx={{ px: 0, py: 0.5 }}>
                <ListItemText
                  primary={
                    <Typography
                      component={Link}
                      to="/careers"
                      variant="body2"
                      sx={{
                        color: '#cbd5e1',
                        textDecoration: 'none',
                        '&:hover': { color: 'white' }
                      }}
                    >
                      Careers
                    </Typography>
                  }
                />
              </ListItem>
            </List>
          </Grid>
        </Grid>

        {/* Bottom Border */}
        <Box sx={{ 
          mt: 4, 
          pt: 4, 
          borderTop: 1, 
          borderColor: '#334155' // healthcare-blue-700
        }}>
          <Box sx={{ 
            display: 'flex', 
            flexDirection: { xs: 'column', md: 'row' }, 
            justifyContent: 'space-between', 
            alignItems: 'center',
            gap: 1
          }}>
            <Typography variant="body2" sx={{ color: '#94a3b8' }}>
              © 2024 UnisynHub. All rights reserved.
            </Typography>
            <Typography variant="caption" sx={{ color: '#64748b' }}>
              HIPAA-compliant where applicable
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;